import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import BasemapEnableButton from "@/v2-backoffice-client/basemap/enable/BasemapEnableButton"
import type { BasemapFragment } from "@/v2-backoffice-client/basemap/__types__/basemap.fragment"

export type BasemapViewToolbarProps = ComponentProps<"div"> & {
  basemap: BasemapFragment | null | undefined
}

/**
 * Lifecycle controls for the basemap sheet. Basemaps skip the layer's
 * review queue — nothing seeds them behind the operator's back — so the
 * whole lifecycle is the one publish/withdraw switch.
 */
function BasemapViewToolbar(props: BasemapViewToolbarProps) {
  const { basemap, ...viewSheetToolbarProps } = props

  if (!basemap) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <BasemapEnableButton basemap={basemap} />
    </ViewSheet.Toolbar>
  )
}

export default BasemapViewToolbar
